module.exports = __webpack_public_path__ + "static/media/Averta-Semibold-Italic.fe530aa3.woff2";